import { buildLoginUrl } from '@shared/ui/auth/login-url';

/**
 * The auth app handles login for every kiss product, so Scope has no login page
 * of its own — it bounces signed-out users there and they come back via
 * `return_to`. Set VITE_AUTH_URL per environment; the fallback is the auth app's
 * local dev port (matching Tasks' convention).
 */
export const authOrigin = import.meta.env.VITE_AUTH_URL ?? 'http://localhost:5173';

/** Leave for the auth app's login, carrying where we were so it can return us. */
export function goToLogin(returnTo: string = window.location.href): void {
	window.location.assign(buildLoginUrl(authOrigin, returnTo));
}

/**
 * Add another account: go to the auth app's sign-in with `add=1`, which shows the form
 * even though a session already exists (a normal visit would bounce a signed-in user
 * straight through). Signing in there folds the new account into the roster and returns
 * here, now switched to it.
 */
export function goToAddAccount(): void {
	// Return to the app ROOT, not the scope we're on: it belongs to the current account
	// and the account being added may not have access to it. Root resolves to the new
	// account's own landing.
	const url = new URL(buildLoginUrl(authOrigin, `${window.location.origin}/`));
	url.searchParams.set('add', '1');
	window.location.assign(url.toString());
}
